let j15VideoBtns = document.querySelectorAll('.Eureka-J15-Ultra .video_button,.new_730_tvc .video_button,.watch_video_btn');
j15VideoBtns.forEach(btn => {
    btn.addEventListener('click', function() {
        const videoSrc = this.getAttribute('data-video');
        let videoEmbed;

        // 检查 videoSrc 是否为 YouTube 链接
        if (videoSrc.includes("youtube.com") || videoSrc.includes("youtu.be")) {
            const videoId = videoSrc.split('v=')[1] || videoSrc.split('/').pop();
            videoEmbed = `
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/${videoId}?autoplay=true&controls=1" 
                    frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            `;
        } else {
            videoEmbed = `<video src="${videoSrc}" controls autoplay style="height: auto; width: 100%;" playsinline></video>`;
        }

        const videoOverlay = document.createElement('div');
        videoOverlay.innerHTML = `
            <div style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.8); display: flex; align-items: center; justify-content: center; z-index: 1000;">
                <div class="videoDrawer">
                    ${videoEmbed}
                    <button id="closeBtn" class="videoCloseBtn">
                        <svg t="1721641088826" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1564" width="46" height="46">
                            <path d="M512 960C264.97 960 64 759.03 64 512S264.97 64 512 64c247.04 0 448 200.97 448 448S759.04 960 512 960z m0-861.54C283.98 98.46 98.46 283.98 98.46 512S283.98 925.54 512 925.54 925.54 740.02 925.54 512 740.02 98.46 512 98.46z" fill="#fff" p-id="1565"></path>
                            <path d="M353.61 687.62c-4.41 0-8.82-1.68-12.18-5.05-6.73-6.73-6.73-17.63 0-24.37l316.78-316.78c6.73-6.73 17.63-6.73 24.37 0s6.73 17.63 0 24.37L365.79 682.57a17.14 17.14 0 0 1-12.18 5.05z" fill="#fff" p-id="1566"></path>
                            <path d="M670.39 687.62c-4.41 0-8.82-1.68-12.18-5.05L341.43 365.79c-6.73-6.73-6.73-17.63 0-24.37s17.63-6.73 24.37 0L682.58 658.2c6.73 6.73 6.73 17.63 0 24.37a17.18 17.18 0 0 1-12.19 5.05z" fill="#fff" p-id="1567"></path>
                        </svg>
                    </button>
                </div>
            </div>
        `;
        document.body.appendChild(videoOverlay);

        const closeBtn = document.getElementById('closeBtn');
        const closeOverlay = () => {
            if (document.body.contains(videoOverlay)) {
                document.body.removeChild(videoOverlay);
            }
        };

        closeBtn.addEventListener('click', closeOverlay);
        videoOverlay.addEventListener('click', closeOverlay);

        // 防止点击视频或iframe时关闭overlay
        videoOverlay.querySelector('video')?.addEventListener('click', event => event.stopPropagation());
        videoOverlay.querySelector('iframe')?.addEventListener('click', event => event.stopPropagation());
    });
});